<main class="main-dashboard">
  <article class="main-canvas">
    <section class="canvas-container">
      <section class="dashboard-items">
        <form [formGroup]="itassetForm">
          <div class="canvas-item">
            <div
              class="canvas-header row justify-content-between align-items-center"
            >
              <div class="title col-sm-6">
                <div class="d-flex align-items-center">
                  <div class="edit">
                    <button title="back page" (click)="backToItAsset()">
                      <span><i class="ri-arrow-left-line"></i></span>
                    </button>
                  </div>
                  <h3 class="px-3">It-Asset Form</h3>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-8">
                <div class="canvas-data">
                  <div class="row">
                    <div class="col-sm-6 px-3 py-1">
                      <div class="input">
                        <div class="input-item">
                          <input
                            type="text"
                            formControlName="assetType"
                            required
                          />
                          <label class="floating-label-special">Asset Type*</label>
                          <i class="ri-shield-user-line"></i>
                        </div>
                        <mat-error *ngIf="f.assetType.touched && f.assetType.invalid" class="alert alert-danger">
                          <mat-error *ngIf="f.assetType.errors.required">Asset Type is required</mat-error>
                        </mat-error>
                      </div>
                    </div>
                    <div class="col-sm-6 px-3 py-1">
                      <div class="input">
                        <div class="input-item">
                          <input
                            formControlName="assetId"
                            type="text"
                            required
                          />
                          <label for="assetId" class="floating-label-special"
                            >Asset Id*</label
                          >
                          <i class="ri-user-follow-line"></i>
                        </div>
                        <mat-error *ngIf="f.assetId.touched && f.assetId.invalid" class="alert alert-danger">
                          <mat-error *ngIf="f.assetId.errors.required">Asset Id is required</mat-error>
                          <mat-error *ngIf="f.assetId.errors.pattern">Asset Id can contain AlphaNumeric characters</mat-error>
                        </mat-error>
                      </div>
                    </div>
                    <div class="col-sm-6 px-3 py-1">
                      <div class="input">
                        <div class="input-item">
                          <input formControlName="macId" type="text" />
                          <label for="macId" class="floating-label-special"
                            >Mac Id</label
                          >
                          <i class="ri-computer-fill"></i>
                        </div>
                      </div>
                    </div>

                    <div class="col-sm-6 px-3 py-1">
                      <div class="input">
                        <div class="input-item">
                          <input
                            list="userList"
                            formControlName="user"
                            placeholder=" Select User"
                          />
                          <datalist id="userList">
                            <option
                              [value]="item"
                              *ngFor="let item of userDropdownList"
                            ></option>
                          </datalist>
                          <label class="floating-label-special">User*</label>
                          <i class="ri-file-copy-2-line"></i>
                        </div>
                        <mat-error *ngIf="f.user.touched && f.user.invalid" class="alert alert-danger">
                          <mat-error *ngIf="f.user.errors.required">User is required</mat-error>
                         </mat-error>
                      </div>
                    </div>
                    <div class="col-sm-6 px-3 py-1">
                      <div class="input">
                        <div class="input-item">
                          <input
                            formControlName="department"
                            type="text"
                          />
                          <label for="department" class="floating-label-special"
                            >Department</label
                          >
                          <i class="ri-file-list-3-line"></i>
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-6 px-3 py-1">
                      <div class="input">
                        <div class="input-item">
                          <input formControlName="model" type="text" required />
                          <label for="model" class="floating-label-special"
                            >Make/Model*</label
                          >
                          <i class="ri-list-ordered"></i>
                        </div>
                        <mat-error *ngIf="f.model.touched && f.model.invalid" class="alert alert-danger">
                          <mat-error *ngIf="f.model.errors.required">Model is required</mat-error>
                          <mat-error *ngIf="f.model.errors.pattern">Model can contain AlphaNumeric characters</mat-error>
                        </mat-error>
                      </div>
                    </div>
                    <div class="col-sm-6 px-3 py-1">
                      <div class="input">
                        <div class="input-item">
                          <input formControlName="sn" type="text" required />
                          <label for="sn" class="floating-label-special">SN*</label>
                          <i class="ri-shield-user-line"></i>
                        </div>
                        <mat-error *ngIf="f.sn.touched && f.sn.invalid" class="alert alert-danger">
                          <mat-error *ngIf="f.sn.errors.required">SN is required</mat-error>
                        </mat-error>
                      </div>
                    </div>
                    <div class="col-sm-6 px-3 py-1">
                      <div class="input">
                        <div class="input-item">
                          <input formControlName="pn" type="text" />
                          <label for="pn" class="floating-label">PN</label>
                          <i class="ri-shield-user-line"></i>
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-6 px-3 py-1">
                      <div class="input">
                        <div class="input-item">
                          <input
                            formControlName="warranty"
                            type="date"
                          />
                          <label for="warranty" class="floating-label-special"
                            >Warranty End Date</label
                          >
                          <i class="ri-shield-user-line"></i>
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-6 px-3 py-1">
                      <div class="input">
                        <div class="input-item">
                          <input
                            formControlName="installDate"
                            type="date"
                            required
                          />
                          <label for="" class="floating-label-special"
                            >Asset Inward Date*</label
                          >
                          <i class="ri-calendar-check-line"></i>
                        </div>
                        <mat-error *ngIf="f.installDate.touched && f.installDate.invalid" class="alert alert-danger">
                          <mat-error *ngIf="f.installDate.errors.required">Install Date is required</mat-error>
                        </mat-error>
                      </div>
                    </div>
                    <div class="col-sm-6 px-3 py-1">
                      <div class="input">
                        <div class="input-item">
                          <input formControlName="installationReleaseDate" type="date" />
                          <label for="installationReleaseDate" class="floating-label-special">Asset Outward Date</label>
                          <i class="ri-calendar-check-line"></i>
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-6 px-3 py-1">
                      <div class="input">
                        <div class="input-item">
                          <input formControlName="os" type="text" />
                          <label for="os" class="floating-label">OS</label>
                          <i class="ri-shield-user-line"></i>
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-6 px-3 py-1">
                      <div class="input">
                        <div class="input-item">
                          <input
                            formControlName="vendor"
                            type="text"
                            required
                          />
                          <label for="vendor" class="floating-label-special"
                            >Vendor*</label
                          >
                          <i class="ri-user-2-line"></i>
                        </div>
                        <mat-error *ngIf="f.vendor.touched && f.vendor.invalid" class="alert alert-danger">
                          <mat-error *ngIf="f.vendor.errors.required">Vendor is required</mat-error>
                        </mat-error>
                      </div>
                    </div>
                    <div class="col-sm-6 px-3 py-1">
                      <div class="input">
                        <div class="input-item">
                          <input
                            formControlName="location"
                            type="text"
                          />
                          <label for="location" class="floating-label"
                            >Location</label
                          >
                          <i class="ri-map-pin-line"></i>
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-6 px-3 py-1">
                      <div class="input">
                        <div class="input-item">
                          <input
                            formControlName="processor"
                            type="text"
                          />
                          <label for="processor" class="floating-label"
                            >Processor</label
                          >
                          <i class="ri-settings-5-fill"></i>
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-6 px-3 py-1">
                      <div class="input">
                        <div class="input-item">
                          <input formControlName="ram" type="text" />
                          <label for="ram" class="floating-label">Ram</label>
                          <i class="ri-file-hwp-fill"></i>
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-6 px-3 py-1">
                      <div class="input">
                        <div class="input-item">
                          <input
                            formControlName="harddisk"
                            type="text"
                          />
                          <label for="harddisk" class="floating-label"
                            >HardDisk</label
                          >
                          <i class="ri-hard-drive-fill"></i>
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-6 px-3 py-1">
                      <div class="input">
                        <div class="input-item">
                          <input
                            formControlName="display"
                            type="text"
                          />
                          <label for="display" class="floating-label"
                            >Display</label
                          >
                          <i class="ri-tv-2-line"></i>
                        </div>
                      </div>
                    </div>

                    <!-- <div class="col-sm-6 px-3 py-1">
                      <div class="input">
                        <div class="input-item">
                          <input
                            formControlName="configuration"
                            type="text"
                          />
                          <label for="configuration" class="floating-label"
                            >Configuration</label
                          >
                          <i class="ri-tv-2-line"></i>
                        </div>
                      </div>
                    </div> -->

                    <div class="col-sm-6 px-3 py-1">
                      <div class="input">
                        <div class="input-item">
                          <input
                            formControlName="rentalCost"
                            type="text"
                          />
                          <label for="rentalCost" class="floating-label"
                            >Rental Cost</label
                          >
                          <i class="ri-price-tag-3-fill"></i>
                        </div>
                        <mat-error *ngIf="f.rentalCost.touched && f.rentalCost.invalid" class="alert alert-danger">
                          <mat-error *ngIf="f.rentalCost.errors.pattern">Rental Cost must have decimal number</mat-error>
                        </mat-error>
                      </div>
                    </div>
                    <div class="col-sm-6 px-3 py-1">
                      <div class="input">
                        <div class="input-item">
                          <input
                            formControlName="graphicsCard"
                            type="text"
                          />
                          <label for="display" class="floating-label"
                            >Graphic Card</label
                          >
                          <i class="ri-sd-card-mini-fill"></i>
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-6 px-3 py-1">
                      <div class="input">
                        <div class="input-item">
                          <input
                            formControlName="role"
                            type="text"
                          />
                          <label for="role" class="floating-label"
                            >Role</label
                          >
                          <i class="ri-account-box-fill"></i>
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-6 px-3 py-1">
                      <div class="input">
                        <div class="input-item">
                          <input
                            formControlName="invoiceNo"
                            type="text"
                          />
                          <label for="invoiceNo" class="floating-label"
                            >Invoice No</label
                          >
                          <i class="ri-bill-fill"></i>
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-6 px-3 py-1">
                      <div class="input">
                        <div class="input-item">
                          <input
                            formControlName="version"
                            type="text"
                          />
                          <label for="display" class="floating-label"
                            >Version</label
                          >
                          <i class="ri-stack-fill"></i>
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-6 px-3 py-1">
                      <div class="input">
                        <div class="input-item">
                          <input
                            formControlName="availableQuantity"
                            type="text"
                          />
                          <label for="availableQuantity" class="floating-label"
                            >Available Quantity</label
                          >
                          <i class="ri-numbers-fill"></i>
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-6 px-3 py-1">
                      <div class="input">
                        <div class="input-item">
                          <select formControlName="state">
                            <option value="" disabled selected>
                              Select Status
                            </option>
                            <option value="Use">Use</option>
                            <option value="Not in Use">Not in Use</option>
                          </select>
                          <label class="floating-label floating-label-special"> Status</label>
                          <i class="ri-logout-box-r-line"></i>
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-6 px-3 py-1">
                      <div class="input">
                        <div class="input-item">
                          <select formControlName="eligibleSystem">
                            <option value="" disabled selected>
                              Select Status
                            </option>
                            <option [ngValue]="true">Yes</option>
                            <option [ngValue]="false">No</option>
                          </select>
                          <label class="floating-label floating-label-special">Consider for Shift Allocation</label>
                          <i class="ri-logout-box-r-line"></i>
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-6 px-3 py-1">
                      <div class="input">
                        <div class="input-item">
                          <select formControlName="keyboard">
                            <option value="" disabled selected>
                              Keyboard Status
                            </option>
                            <option value="Yes">Yes</option>
                            <option value="No">No</option>
                          </select>
                          <label class="floating-label floating-label-special">Keyboard</label>
                          <i class="ri-keyboard-box-fill"></i>
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-6 px-3 py-1">
                      <div class="input">
                        <div class="input-item">
                          <select formControlName="mouse">
                            <option value="" disabled selected>
                              Mouse Status
                            </option>
                            <option value="Yes">Yes</option>
                            <option value="No">No</option>
                          </select>
                          <label class="floating-label floating-label-special">Mouse</label>
                          <i class="ri-mouse-fill"></i>
                        </div>
                      </div>
                    </div>
                    <!-- <div class="col-sm-6 px-3 py-1">
                      <input
                        formControlName="keyboard"
                        label="Keyboard"
                        type="checkbox"
                        required
                      />
                      <label class="form-check-label" for="flexCheckChecked">
                        Keyboard
                      </label>
                    </div>

                    <div class="col-sm-6 px-3 py-1">
                      <input
                        formControlName="mouse"
                        label="Mouse"
                        type="checkbox"
                        required
                      />
                      <label class="form-check-label" for="flexCheckChecked">
                        Mouse
                      </label>
                    </div> -->

                    <div class="row justify-content-end align-items-center">
                      <div class="modal-footer">
                        <button
                          type="button"
                          class="btn btn-primary"
                          (click)="cancelButton()"
                        >
                          Cancel
                        </button>
                        <button
                          type="button"
                          class="btn btn-primary"
                          *ngIf="!this.ItAssetId"
                          (click)="createItAsset()"
                          [disabled]="!itassetForm.valid"
                        >
                          Create
                        </button>
                        <button
                          type="button"
                          class="btn btn-primary"
                          (click)="updateItAsset()"
                          [disabled]="!itassetForm.valid"
                          *ngIf="this.ItAssetId"
                        >
                          Update
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </section>
    </section>
  </article>
</main>
